/**
 *    Custom scroll
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Custom scroll
 *
 */


/**
 *     @section 1. Dependencies
 */

import Constants from '../settings/_variables';
import PerfectScrollbar from 'perfect-scrollbar';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('custom scroll loaded ...');

        this.customScroll();
    },

    // @section 2.2 Custom scroll
    customScroll() {

        // every custom scroll module
        $(`.${Constants.prefix}custom-scroll`).each(function(i,e) {
            let ps = new PerfectScrollbar($(e)[0], {
                minScrollbarLength: 45,
                maxScrollbarLength: 45,
                scrollingThreshold: 0,
                wheelPropagation: true,
                swipePropagation: false
            });

            $(window).resize(function () {
                ps.update($(e)[0]);
            }).resize();
        });

    }
};

// end of _custom-scroll.js
